/* eslint-disable no-param-reassign */
import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type { RootState } from '..';

interface LayoutState {
  isMenuOpen: boolean;
}

const initialState: LayoutState = {
  isMenuOpen: false,
};
const layoutSlice = createSlice({
  initialState,
  name: 'layout',
  reducers: {
    setMenuOpen: (state, { payload }: PayloadAction<boolean>) => {
      state.isMenuOpen = payload;
    },
  },
});

export const selectIsMenuOpen = (state: RootState) => state.layout.isMenuOpen;

export const { setMenuOpen } = layoutSlice.actions;

export default layoutSlice;
